import type { SVGProps } from 'react';
const SvgFarm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.5 19.5v-9h3.603l.731-1.569a2.25 2.25 0 0 1 1.104-1.093A3.5 3.5 0 0 0 7.5 5 3.5 3.5 0 0 0 4 8.5v11A1.5 1.5 0 0 0 5.5 21h3.128a2.74 2.74 0 0 1-.619-1.5zM9.5 9h-4v-.5c0-1.103.897-2 2-2s2 .897 2 2zm2.56 1.075 3.44-1.506 3.44 1.506 1.56 3.344v5.831a.25.25 0 0 1-.25.25H17.5v-1.75c0-.69-.56-1.25-1.25-1.25h-1.5c-.69 0-1.25.56-1.25 1.25v1.75h-2.75a.25.25 0 0 1-.25-.25v-5.834l1.56-3.344zM16 7.15a1.25 1.25 0 0 0-1.003 0l-3.625 1.588a1.25 1.25 0 0 0-.631.615l-1.622 3.478A1.24 1.24 0 0 0 9 13.36v5.891c0 .966.784 1.75 1.75 1.75h9.5c.966 0 1.75-.784 1.75-1.75v-5.89c0-.182-.04-.363-.119-.529L20.26 9.353a1.25 1.25 0 0 0-.63-.615zm-2 5.6v1.5c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75v-1.5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75"
    />
  </svg>
);
export default SvgFarm;
